import { render, staticRenderFns } from "./pendingItemsList.vue?vue&type=template&id=3539448a&"
import script from "./pendingItemsList.vue?vue&type=script&lang=js&"
export * from "./pendingItemsList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports